import { IOption } from "../../components/SelectDropdown";
import { allergyService } from "../../services/allergyService";

/**
 * Searches SNOMED allergies server-side and maps them to the option shape used
 * by SnomedSelect. The full allergy list is never fetched to the client.
 */
export async function searchAllergyOptions(
  search: string,
  limit = 50
): Promise<IOption[]> {
  const { data } = await allergyService.searchAllergies(search, limit);

  return data.map((allergy) => ({
    label: `${allergy.preferredTerm} - ${allergy.conceptId}`,
    value: allergy.conceptId.toString(),
    key: `allergy-${allergy.conceptId}`,
  }));
}
